// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.principal-page,
.principal-page * {
  box-sizing: border-box;
}

.principal-page {
  min-height: 100vh;
  overflow: hidden;
}

.principal-page .layout-container,
.principal-page .layout-page {
  min-height: 100vh;
}

.principal-page .principal-navbar-wrap {
  position: relative;
  z-index: 1002;
}

.principal-page .img-wrapper {
  position: relative;
  width: 100%;
  height: calc(100vh - 80px);
  min-height: 0;
  overflow: hidden;
  background: #eef3f7;
}

.principal-page .background-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

.principal-page .principal-mobile-bottom-nav {
  display: none;
}

@media (max-width: 1199px) {
  body.principal-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  body.principal-responsive-page .sidenav---sidenav---_2tBP {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 12000;
    width: 0;
    min-width: 0;
    overflow: hidden;
    transform: translateX(-100%);
    transition: width 0.2s ease, transform 0.2s ease;
  }

  body.principal-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
    width: min(280px, 86vw);
    min-width: min(280px, 86vw);
    overflow-y: auto;
    transform: translateX(0);
    box-shadow: 8px 0 24px rgba(15, 39, 60, 0.22);
  }

  body.principal-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {
    display: block;
  }

  /* El menu de usuario se comporta como el offcanvas fullscreen de Trafico. */
  body.principal-responsive-page .principal-responsive-offcanvas {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: auto;
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh;
    z-index: 13000;
    box-sizing: border-box;
  }

  body.principal-responsive-page .offcanvas-backdrop {
    z-index: 12990;
  }

  .principal-page .custom-navbar-admin {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .principal-page .img-wrapper {
    height: calc(100vh - 64px);
  }
}

@media (max-width: 767px) {
  .principal-page .custom-navbar-admin {
    min-height: 60px;
    padding: 4px 8px;
  }

  .principal-page .custom-navbar-admin .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
    object-fit: contain;
    object-position: left center;
  }

  .principal-page .img-wrapper {
    height: calc(100vh - 60px);
    padding-bottom: 0;
  }

  .principal-page .background-img {
    object-position: center center;
  }

  .principal-page .principal-mobile-bottom-nav {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1100;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    height: 64px;
    padding: 6px 8px calc(6px + env(safe-area-inset-bottom));
    border-top: 1px solid #d9e5ef;
    background: rgba(255, 255, 255, 0.97);
    box-shadow: 0 -4px 16px rgba(31, 55, 80, 0.12);
  }

  .principal-page .principal-mobile-bottom-nav a,
  .principal-page .principal-mobile-bottom-nav button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    padding: 4px 2px;
    border: 0;
    border-radius: 10px;
    background: transparent;
    color: #5a7188;
    font: inherit;
    font-size: 11px;
    text-decoration: none;
    cursor: pointer;
  }

  .principal-page .principal-mobile-bottom-nav i {
    font-size: 22px;
    line-height: 1;
  }

  .principal-page .principal-mobile-bottom-nav a.active,
  .principal-page .principal-mobile-bottom-nav a:hover,
  .principal-page .principal-mobile-bottom-nav button:hover {
    color: #006699;
    background: #eaf4fb;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/principalResponsive.css"],"names":[],"mappings":"AAAA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,gDAAgD;EAClD;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;EAChB;;EAEA,4EAA4E;EAC5E;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,gDAAgD;IAChD,YAAY;IACZ,wDAAwD;IACxD,6BAA6B;IAC7B,qCAAqC;IACrC,8CAA8C;EAChD;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;;IAGE,cAAc;IACd,mBAAmB;EACrB;AACF","sourcesContent":[".principal-page,\n.principal-page * {\n  box-sizing: border-box;\n}\n\n.principal-page {\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n.principal-page .layout-container,\n.principal-page .layout-page {\n  min-height: 100vh;\n}\n\n.principal-page .principal-navbar-wrap {\n  position: relative;\n  z-index: 1002;\n}\n\n.principal-page .img-wrapper {\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 80px);\n  min-height: 0;\n  overflow: hidden;\n  background: #eef3f7;\n}\n\n.principal-page .background-img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center center;\n}\n\n.principal-page .principal-mobile-bottom-nav {\n  display: none;\n}\n\n@media (max-width: 1199px) {\n  body.principal-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  body.principal-responsive-page .sidenav---sidenav---_2tBP {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 12000;\n    width: 0;\n    min-width: 0;\n    overflow: hidden;\n    transform: translateX(-100%);\n    transition: width 0.2s ease, transform 0.2s ease;\n  }\n\n  body.principal-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n    width: min(280px, 86vw);\n    min-width: min(280px, 86vw);\n    overflow-y: auto;\n    transform: translateX(0);\n    box-shadow: 8px 0 24px rgba(15, 39, 60, 0.22);\n  }\n\n  body.principal-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {\n    display: block;\n  }\n\n  /* El menu de usuario se comporta como el offcanvas fullscreen de Trafico. */\n  body.principal-responsive-page .principal-responsive-offcanvas {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: auto;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100vh;\n    z-index: 13000;\n    box-sizing: border-box;\n  }\n\n  body.principal-responsive-page .offcanvas-backdrop {\n    z-index: 12990;\n  }\n\n  .principal-page .custom-navbar-admin {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .principal-page .img-wrapper {\n    height: calc(100vh - 64px);\n  }\n}\n\n@media (max-width: 767px) {\n  .principal-page .custom-navbar-admin {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .principal-page .custom-navbar-admin .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .principal-page .img-wrapper {\n    height: calc(100vh - 60px);\n    padding-bottom: 0;\n  }\n\n  .principal-page .background-img {\n    object-position: center center;\n  }\n\n  .principal-page .principal-mobile-bottom-nav {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1100;\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    height: 64px;\n    padding: 6px 8px calc(6px + env(safe-area-inset-bottom));\n    border-top: 1px solid #d9e5ef;\n    background: rgba(255, 255, 255, 0.97);\n    box-shadow: 0 -4px 16px rgba(31, 55, 80, 0.12);\n  }\n\n  .principal-page .principal-mobile-bottom-nav a,\n  .principal-page .principal-mobile-bottom-nav button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n    padding: 4px 2px;\n    border: 0;\n    border-radius: 10px;\n    background: transparent;\n    color: #5a7188;\n    font: inherit;\n    font-size: 11px;\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  .principal-page .principal-mobile-bottom-nav i {\n    font-size: 22px;\n    line-height: 1;\n  }\n\n  .principal-page .principal-mobile-bottom-nav a.active,\n  .principal-page .principal-mobile-bottom-nav a:hover,\n  .principal-page .principal-mobile-bottom-nav button:hover {\n    color: #006699;\n    background: #eaf4fb;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
